import {
  Routes as Switch,
  Route,
  useMatch as useRouteMatch,
  Navigate as Redirect,
  Outlet
} from 'react-router-dom';
import Home from './main';
import { Body } from 'components/reportBody';
import RicercaStoriaUABox from 'views/ricercaStoriaUABox';
import CodificheTerritorialiUABox from 'views/codificheTerritorialiBox';
import CaratteristicheClassificazioniBox from 'views/caratteristicheClassificazioniBox';
import GeografieEuropeeClassificazioni from 'views/geografieEuropeeClassificazioni';
import BodyCompiler from 'components/reportBody/newReportCompiler';
import { AggiornamentiTable } from 'components/aggiornamentiTable';
const HomeIndex = ({ isMobile, defaultSkip, queryString }) => {
  const path = '';
  return (
  <Switch>  
    
      <Route exact path={path} element={
        <Home
          isMobile={isMobile}
          defaultSkip={defaultSkip}
          queryString={queryString}
        />}
      />

      <Route exact path={`${path}/link`} element={
        <BodyCompiler 
          mainTitle={undefined}
          defaultSkip={defaultSkip}
          queryString={queryString} 
        />} 
      />

      <Route path={`${path}/cambiamenti-unita-territoriali/*`} element={
        <RicercaStoriaUABox
          defaultSkip={defaultSkip}
          queryString={queryString}
        />} 
      />

      <Route path={`${path}/codifiche-territoriali/*`} element={
        <CodificheTerritorialiUABox 
          defaultSkip={defaultSkip}
          queryString={queryString}
        />} 
      />

      <Route path={`${path}/caratteristiche-classificazioni/*`} element={
        <CaratteristicheClassificazioniBox
          defaultSkip={defaultSkip}
          queryString={queryString}
        />} 
      />

      <Route path={`${path}/geo-eu-clas/*`} element={
        <GeografieEuropeeClassificazioni
          defaultSkip={defaultSkip}
          queryString={queryString}
        />}  
      />

      <Route exact path={`${path}/aggiornamenti`} element={
        <AggiornamentiTable
          mainTitle={'Aggiornamenti'}
          defaultSkip={defaultSkip}
          queryString={queryString}
        />}
      />

      <Route exact path={`${path}/in-evidenza`} element={
        <BodyCompiler
          mainTitle={'In evidenza'}
          defaultSkip={defaultSkip}
          queryString={queryString} 
        />} 
      />

      <Route exact path={`${path}/piu-consultati`} element={
        <BodyCompiler
          mainTitle={'I più consultati'}
          defaultSkip={defaultSkip}
          queryString={queryString}
        />} 
      />
      
      <Route path={`${path}/*`} exact={true} element={<Redirect to="/home" />} />

    </Switch>
  );
};

export default HomeIndex;
